import { render } from "./ComponentAnalysis.vue?vue&type=template&id=50c73500&scoped=true"
import script from "./ComponentAnalysis.vue?vue&type=script&lang=js"
export * from "./ComponentAnalysis.vue?vue&type=script&lang=js"

import "./ComponentAnalysis.vue?vue&type=style&index=0&id=50c73500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c73500"]])

export default __exports__